/*
 *
 * LanguageProvider constants
 *
 */

const CHANGE_LOCALE = 'app/LanguageToggle/CHANGE_LOCALE';

export default CHANGE_LOCALE;
